const CART_ID_KEY = "cartId";

export const getCartId = () => localStorage.getItem(CART_ID_KEY) ?? undefined;

export const setCartId = (id: string) => {
    localStorage.setItem(CART_ID_KEY, id);
};
